export enum StatusaiEnum {
  ACTIVE = 'A',
  INACTIVE = 'I'
}
